import type {RequestParameters, GraphQLResponse, Variables} from 'relay-runtime'
import {Observable} from 'relay-runtime'
import {fetchGraphQLWithSubscription} from '@github-ui/fetch-graphql'
import {getSession} from '@github-ui/alive'
import {connectAliveSubscription} from '@github-ui/alive/connect-alive-subscription'

/**
 * Function to configure the Relay store so that it can handle subscriptions
 */
export function subscribe(operation: RequestParameters, variables: Variables): Observable<GraphQLResponse> {
  const persistedQueryId = operation.id

  return Observable.create<GraphQLResponse>(observer => {
    let unsubscribeFromAlive = () => {}
    let closed = false

    async function subscribeToAlive() {
      // Connect the subscription
      if (!persistedQueryId) {
        throw new Error('unexpected operation with no id!')
      }
      const scope = operation.metadata?.scope as string | undefined
      const {subscriptionId: channelName, response} = await fetchGraphQLWithSubscription(
        persistedQueryId,
        variables,
        'GET',
        {isSubscription: true, scope},
      )
      if (response) {
        observer.next(response)
      }
      try {
        const aliveSession = await getSession()
        if (closed) {
          // observable was closed before graphql fetch returned
          // this is fine, we just don't subscribe to the channel on the alive side
          return
        }

        const resp = connectAliveSubscription<GraphQLResponse>(aliveSession, channelName, data => observer.next(data))
        if (resp?.unsubscribe) {
          unsubscribeFromAlive = resp.unsubscribe
        }
      } catch (e) {
        // @ts-expect-error catch blocks are bound to `unknown` so we need to validate the type before using it
        observer.error(e)
      }
    }

    subscribeToAlive()

    // Return object with cleanup function
    // per https://github.com/facebook/relay/blob/aadd54d373cea6e096b95985ad0cdf298d7a7374/packages/relay-runtime/network/RelayObservable.js#L20-L23
    return {
      get closed() {
        return closed
      },
      unsubscribe() {
        closed = true
        unsubscribeFromAlive()
      },
    }
  })
}
